import { HttpClient } from '@angular/common/http';
import { Provider } from '@angular/core';
import { provideChildTranslateService, TranslateLoader } from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from './multi-translate-http-loader';

export function provideFeatureTranslations(featurePaths: string[]): Provider {
  const pathPrefix = '/assets/i18n/';
  const i18nResourcesArray: string[] = featurePaths.map((path) => {
    return `${pathPrefix}${path}`;
  });
  return provideChildTranslateService({
    extend: true,
    loader: {
      provide: TranslateLoader,
      useFactory: (http: HttpClient) => new MultiTranslateHttpLoader(http, i18nResourcesArray),
      deps: [HttpClient],
    },
  });
}
